import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pq_content"
};
import { ElMessage } from 'element-plus';
import { ref, getCurrentInstance, watch, useAttrs } from 'vue';
/* 数据层 */

export default {
  __name: 'lcDailogPQ',
  props: ['ids', 'pQshow', 'planStratTime'],
  emits: ['update:pQshow'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      proxy
    } = getCurrentInstance();
    const formatset = ref('YYYY/MM/DD');
    const props = __props;
    let theplanStratTime = ref(JSON.parse(JSON.stringify(props.planStratTime)));
    const attrs = useAttrs();
    /* 方法 */
    const emits = __emit;
    // 确认
    function makeSure() {
      if (props.ids) {
        proxy.$http.showLoading(false).get('project/task/ch_status', {
          ids: props.ids,
          type: 0,
          plan_start_time: theplanStratTime.value
        }).then(res => {
          // 刷新爷组件详情数据接口
          if (res.errno == 200) {
            attrs.deppgetPageInfo();
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      }
      emits('update:pQshow', false);
    }
    //关闭的点击事件
    function handleClose() {
      emits('update:pQshow', false);
    }
    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        title: "任务排期",
        "model-value": __props.pQshow,
        width: "300px",
        "before-close": handleClose,
        center: false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("label", null, "预计开始时间", -1)), _createVNode(_component_el_date_picker, {
          type: "date",
          placeholder: "选择日期",
          modelValue: _unref(theplanStratTime),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(theplanStratTime) ? theplanStratTime.value = $event : theplanStratTime = $event),
          style: {
            "width": "100%",
            "margin-left": "-10px"
          },
          "value-format": formatset.value,
          format: formatset.value
        }, null, 8, ["modelValue", "value-format", "format"])]), _createElementVNode("div", {
          class: "pq_content",
          style: {
            "justify-content": "right",
            "margin-top": "15px"
          }
        }, [_createElementVNode("div", {
          class: "l-button pqbt",
          onClick: handleClose
        }, "取消"), _createElementVNode("div", {
          class: "l-button",
          style: {
            "margin-right": "0",
            "margin-left": "15px"
          },
          onClick: makeSure
        }, "确认")])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
};